import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default class EllipsisExpand extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func,
  }

  static defaultProps = {
    onClick: () => { },
  }

  state = {
    expanded: false,
  }

  get classNames() {
    const { className } = this.props;
    const { expanded } = this.state;
    return classNames({
      [className]: className,
      'ellipsis': !expanded,
      'white-space-normal': expanded,
    });
  }

  handleClick = (e) => {
    const { onClick } = this.props;
    const { expanded } = this.state;
    this.setState({
      expanded: !expanded,
    }, () => onClick(e, !expanded));
  }

  render() {
    const { children } = this.props;
    return(
      <div
        className={this.classNames}
        onClick={this.handleClick}
      >
        {children}
      </div>
    );
  }
}
